
import "./App.css";
import Main from "./Main.js";
import "../src/css/Style.css"
import "../src/css/Responsive.css"
import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect } from "react";
import whatsapp_icon from '../src/assets/images/whatsapp_icon.webp'

function App() {
  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);
  return (
    <div className="App">
      <Main />
      <a href="https://api.whatsapp.com/send?phone=9047745477" target="_blank" className="Whatsapp_Icon">
        <img alt="Whatsapp" src={whatsapp_icon} style={{ height: '3rem', width: '3rem' }} />
      </a>
    </div>
  );
}

export default App;
